const gates = [];
/** Returns the unregister function. */
export function registerInterpreterAvailabilityGate(next) {
    gates.push(next);
    return () => {
        const index = gates.indexOf(next);
        if (index >= 0) {
            gates.splice(index, 1);
        }
    };
}
function allows(gate) {
    try {
        return gate.allowsJoin();
    }
    catch {
        return true;
    }
}
/** The first gate with a question, hard gates first; `passed` were answered in this attempt. */
function blockingGate(passed = new Set()) {
    const open = gates.filter(gate => !passed.has(gate) && !allows(gate));
    return open.find(gate => gate.hard) || open[0];
}
export function availabilityGateAllowsJoin() {
    return !blockingGate();
}
function throughGates(proceed, passed) {
    const gate = blockingGate(passed);
    if (!gate) {
        proceed();
        return;
    }
    gate.requestJoin(() => {
        passed.add(gate);
        throughGates(proceed, passed);
    });
}
/** Go Available now, or once the interpreter has answered every gate's question. */
export function goAvailableThroughGate(proceed) {
    throughGates(proceed, new Set());
}
